/* global axios */
import ApiClient from './ApiClient';

class EvolutionAPI extends ApiClient {
  constructor() {
    super('evolution', { accountScoped: true });
  }

  checkConfig() {
    return axios.get(`${this.url}/check_config`);
  }

  getInstances() {
    return axios.get(this.url);
  }

  getInstance(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }

  // Create new instance + inbox + connect (collection route, no inbox ID)
  connectNew(instanceName) {
    return axios.post(`${this.url}/connect`, { instance_name: instanceName });
  }

  // Reconnect existing instance (member route, with inbox ID)
  connectInbox(inboxId) {
    return axios.post(`${this.url}/${inboxId}/connect`);
  }

  getQrCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/qrcode`);
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/status`);
  }

  // Pairing code — connect without QR, just numeric code
  pair(inboxId, phone) {
    return axios.post(`${this.url}/${inboxId}/pair`, { phone });
  }

  updateEventsWebhook(inboxId, url) {
    return axios.post(`${this.url}/${inboxId}/update_events_webhook`, {
      events_webhook_url: url,
    });
  }

  updateSettings(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/update_settings`, data);
  }

  // Disconnect — keeps session, can reconnect without QR
  disconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disconnect`);
  }

  // Logout — removes session, needs new QR scan
  logout(inboxId) {
    return axios.post(`${this.url}/${inboxId}/logout`);
  }

  deleteInstance(inboxId) {
    return axios.delete(`${this.url}/${inboxId}`);
  }
}

export default new EvolutionAPI();
